module.exports = __webpack_public_path__ + "static/media/no-result.6c7e4585.svg";